import "./StarRating.css";

function StarRating({ rating, size = 16 }) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="star-rating" style={{ fontSize: size }}>
      {Array(fullStars)
        .fill(0)
        .map((_, i) => (
          <span key={`full-${i}`} className="star full">★</span>
        ))}

      {hasHalfStar && <span className="star half">★</span>}

      {Array(emptyStars)
        .fill(0)
        .map((_, i) => (
          <span key={`empty-${i}`} className="star empty">★</span>
        ))}
    </div>
  );
}

export default StarRating;
